<template>
    <div class = "mainContainer">
        <div class = "loadingContainer" v-if="isLoading">
            <v-progress-circular
              indeterminate
              class = "loader"
              :size = "50"
              ></v-progress-circular>
        </div>
        <div v-if = "innerStepper === 2 && isLoading === false">
            <p class = "escrowText">Withdraw</p>
                <ValidationProvider
                    style="width: 100%"
                    name="Amount"
                    :rules="amountRules"
                    v-slot="{ errors, classes }"
                >
                    <div class = "superContainer mb-30">
                        <div class = "inputContainer" :class="classes">
                            &#x20B9;
                            <input
                                id = "amountId"
                                maxLength="7"
                                onKeyPress="if(this.value.length==7) return false;"
                                type="number"
                                class="center"
                                v-model="amount"
                                placeholder="0"
                                autofocus
                                v-on:keyup="adjustInput"
                                @input="validateAmount"
                            />
                        </div>
                        <small class="errorText">{{ errors[0] }}</small>
                    </div>
                    <div class = "inputContainer">
                        <button class="buttonSubmit btn_new btn-secondary-new" @click="withdrawMoney()" :disabled="!(errors.length === 0) || !amount">Withdraw</button>
                    </div>
                </ValidationProvider>
        </div>
        <div v-if = "innerStepper === 3 && isLoading === false">
            <div class="imageContainer">
              <img src = '/img/Success.svg'>
              <p class = "successfulText">Request Submitted Successfully</p>
              <span class = "processText">It might take 24-48 hours to process your withdrawal</span>
            </div>
        </div>
    </div>
  </template>

<script>
import LenderService from '@/services/lenderService'
export default {
    name: 'withdrawScreen',
    props: {
        step: Number,
        incomeAmount: Number,
        escrowBalance: Number,
        withdrawType: String
    },
    watch: {
        step: {
            handler (newValue, oldValue) {
                this.innerStepper = newValue
            },
            deep: true,
            immediate: true
        }
    },
    data () {
        return {
            escrowAmount: this.escrowBalance,
            isLoading: false,
            amountRules: 'amountValidation:5000000,1|required',
            amount: null,
            innerStepper: this.step
        }
    },
    created () {
        if (this.withdrawType === 'income') {
            this.amount = this.incomeAmount
        } else if (this.withdrawType === 'escrowBalance') {
            this.amount = this.escrowBalance - this.incomeAmount
        }
    },
    mounted () {
        this.adjustInitializeInput()
        this.amountRules = `amountValidation:${this.amount},1|required`
    },
    methods: {
        handleDialogClose () {
            this.$emit('handleDialogClose')
        },
        adjustInitializeInput () {
            const event = document.getElementById('amountId')
            event.style.width = event.value.length + 'ch'
        },
        adjustInput (event) {
            if (event.target.value.length === 0) {
                event.target.style.width = '15px'
            } else {
                event.target.style.width = event.target.value.length + 'ch'
            }
        },
        validateAmount () {
            const amount = this.amount
            const sep = String(12.21).match(/\D/)[0]
            const b = amount.toString().split(sep)
            if (b[1]) {
                if (b[1].length > 2) {
                    this.amount = b[0] + '.' + b[1].slice(0, 2)
                }
            }
        },
        async withdrawMoney () {
            this.isLoading = true
            const payload = {
                withdrawalAmount: this.amount,
                withdrawalType: this.withdrawType
            }
            await LenderService.withdrawMoney(payload).then((response) => {
                if (response.status === 200) {
                    this.success()
                    this.isLoading = false
                    setTimeout(() => {
                        this.handleDialogClose()
                        window.location.reload()
                    }, 3000)
                } else {
                    this.isLoading = false
                    this.handleDialogClose()
                }
            })
        },
        success () {
            this.$emit('success')
        }
    }
}
</script>

  <style lang="scss" scoped>
    .imageContainer {
        width: 340px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .escrowText {
        text-align: center;
        font-weight: 500;
        font-size: 21px;
        color: #0F0F0F;
      }
    .mainContainer {
        margin-bottom: 40px;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    .superContainer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .errorText {
        color: #e45f5f !important;
        font-size: 12px;
    }
    .inputContainer {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .loader {
        padding-top: 200px;
        height: 42px !important;
        width: 42px !important;
        color: #007AFF;
    }
    .loadingContainer {
        height: 200px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .successfulText {
        text-align: center;
        margin-bottom: 8px !important;
        font-size: 17px;
        padding-top: 25px;
        font-weight: 700;
        color: #27ae60
    }
    .processText {
        text-align: center;
        font-weight: 400;
        font-size: 16px;
        color: #4F4F4F;
    }
  </style>
